import {createStyles, Link, makeStyles, Paper, Theme, Typography} from '@material-ui/core';
import {useBreadcrumbs} from 'Core/hooks/useBreadcrumbs';
import React from 'react';
import {useRouteMatch} from 'react-router-dom';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      [theme.breakpoints.up('lg')]: {
        paddingLeft: theme.spacing(8),
        paddingRight: theme.spacing(8),
      },
      [theme.breakpoints.down('md')]: {
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
      },
    },
    paper: {
      padding: theme.spacing(1),
      margin: theme.spacing(1),
    },
    section: {
      [theme.breakpoints.up('lg')]: {
        width: '50%',
        margin: 'auto',
      },
    },
  })
);

const AllAppAndEnrollMyWay = () => {
  const match = useRouteMatch();
  useBreadcrumbs('AllApp and EnrollMyWay Voice Upload', match.url);
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.section}>
        <Paper className={classes.paper}>
          <Typography variant="h6">AllApp and EnrollMyWay Voice File Upload</Typography>
          <Typography variant="body1">
            <Link target="_blank" href="https://awdfileportal.allstateatwork.com/AgentVoice/">
              Agent Voice Upload
            </Link>
          </Typography>
        </Paper>
      </div>
    </div>
  );
};

export default AllAppAndEnrollMyWay;
